import { render, staticRenderFns } from "./CustomerDeliveryFile.vue?vue&type=template&id=36b9128f&scoped=true"
import script from "./CustomerDeliveryFile.vue?vue&type=script&lang=js"
export * from "./CustomerDeliveryFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b9128f",
  null
  
)

export default component.exports